import Component from "./InfoHide";
export default Component;
